/**
 * Faz 9 menü grubu (Yapay zekâ). Shell.tsx'teki menüye tek satırla eklenir (Faz 8 ayrı dalda — çakışma azalsın).
 * Öğeler sonraki görevlerde (içerik stüdyosu, Copilot, öneriler, talep tahmini) buraya eklenir.
 */
export function aiNavGroup(t: (key: string) => string) {
  return {
    group: t('ai.nav.group'),
    items: [
      { to: '/yapay-zeka/copilot', label: t('ai.nav.copilot'), permission: 'reports.sales.read' },
      { to: '/yapay-zeka/icerik-studyosu', label: t('ai.nav.studio'), permission: 'content.read' },
      { to: '/yapay-zeka/seo-onerileri', label: t('ai.nav.seo'), permission: 'seo.read' },
      { to: '/yapay-zeka/musteri-degeri', label: t('ai.nav.ltv'), permission: 'marketing.audience.read' },
      { to: '/yapay-zeka/youtube', label: t('ai.nav.youtube'), permission: 'seo.read' },
      { to: '/yapay-zeka/oneriler', label: t('ai.nav.recommendations'), permission: 'catalog.product.read' },
      { to: '/yapay-zeka/talep-tahmini', label: t('ai.nav.forecast'), permission: 'inventory.stock.read' },
      { to: '/yapay-zeka/ayarlar', label: t('ai.nav.settings'), permission: 'ai.usage.read' },
    ],
  };
}
